import React, { useContext, useState } from 'react'
import { AuthContext } from '../../context/authContext'
import { authApi } from '../../api/auth/authApi'
import { ToastContext } from '../../context/toastContext'
import Modal from 'react-bootstrap/Modal'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import { Spinner } from 'react-bootstrap'

const AuthModal = ({ show, onHide }) => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  })
  const { setError } = useContext(ToastContext)
  const { setIsAuth, setUserData } = useContext(AuthContext)
  const [loading, setLoading] = useState(false)

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    const res = await authApi.login(formData)
    if (res?.error_code !== 0) {
      setIsAuth(false)
      setError(res.message || 'неизвестная ошибка')
      setLoading(false)
    } else {
      localStorage.setItem('session', res?.session)
      setUserData(res?.userdata || null)

      setIsAuth(true)
      onHide()
      setLoading(false)
    }
  }

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      backdrop="static"
      keyboard={false}
      contentClassName="bg-dark text-light"
    >
      <Modal.Header className="border-secondary">
        <Modal.Title>Вход в систему</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Логин</Form.Label>
            <Form.Control
              type="text"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              required
              className="bg-dark text-light border-secondary"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Пароль</Form.Label>
            <Form.Control
              type="password"
              name="password"
              value={formData.password}
              onChange={handleInputChange}
              required
              className="bg-dark text-light border-secondary"
            />
          </Form.Group>

          <Button type="submit" variant="success" className="w-100">
            {loading ? (
              <Spinner
                style={{ width: '1rem', height: '1rem' }}
                animation="border"
                role="status"
                variant="light"
              >
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            ) : (
              'Войти'
            )}
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  )
}

export default AuthModal
